import styled from "styled-components";
import Title from "@streeteasy/design-system/deprecated/Title";

export const ContactBoxHeader = styled(Title).attrs(props => ({
  as: "h2",
  type: props.isMobile ? "primaryMd" : "secondary"
}))`
  align-items: center;
  display: flex;
  padding: 20px 20px;
  font-weight: ${props => (props.isMobile ? null : "700")};
  text-transform: ${props => (props.isMobile ? null : "uppercase")};
`;
